import { create } from "zustand";
import { api } from "../api";
import type { Settings } from "@shared/types";

interface SettingsState {
  settings: Settings;
  loaded: boolean;
  saving: boolean;
  load: () => Promise<void>;
  save: (patch: Partial<Settings>) => Promise<void>;
}

const defaults: Settings = {
  language: "en",
  targetType: "word",
  mode: "classic",
  timeLimitSeconds: 60,
  difficulty: "normal",
};

export const useSettingsStore = create<SettingsState>((set, get) => ({
  settings: defaults,
  loaded: false,
  saving: false,
  load: async () => {
    try {
      const s = await api.getSettings();
      set({ settings: s, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },
  save: async (patch) => {
    const merged = { ...get().settings, ...patch };
    set({ settings: merged, saving: true });
    try {
      const s = await api.saveSettings(patch);
      set({ settings: s, saving: false });
    } catch {
      set({ saving: false });
    }
  },
}));
